var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { ref: "form", attrs: { "label-position": "left" } },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _vm._l(_vm.value, function(item, index) {
            return _c(
              "el-col",
              { key: item.key, attrs: { span: 3.2 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: index === 0 ? "度数范围:" : "",
                      "label-width": index === 0 ? "80px" : "10px"
                    }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "60px" },
                      attrs: { value: item.start },
                      on: {
                        input: function($event) {
                          return _vm.input(index, $event, "start")
                        }
                      }
                    }),
                    _c("span", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v("至")
                    ]),
                    _c("el-input", {
                      staticStyle: { width: "60px" },
                      attrs: { value: item.end },
                      on: {
                        input: function($event) {
                          return _vm.input(index, $event, "end")
                        }
                      }
                    }),
                    _vm.value.length > 1
                      ? _c("i", {
                          staticClass: "el-icon-close del-icon",
                          on: {
                            click: function($event) {
                              return _vm.delDegrees(index)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c(
            "el-col",
            { staticStyle: { padding: "5px" }, attrs: { span: 1.2 } },
            [
              _c("i", {
                staticClass: "el-icon-plus add-icon",
                on: { click: _vm.addDegrees }
              })
            ]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }